import { dictionaryApi } from './dictionaryClient';

export type UpasargaSubantaLink = {
  id: number;
  upasargaId: number;
  subantaId: number;
};

export type CreateUpasargaSubantaBody = {
  upasargaId: number;
  subantaId: number;
};

export type PatchUpasargaSubantaBody = Partial<
  Pick<UpasargaSubantaLink, 'upasargaId' | 'subantaId'>
>;

function normalizeList(data: unknown): UpasargaSubantaLink[] {
  if (Array.isArray(data)) return data as UpasargaSubantaLink[];
  if (data && typeof data === 'object' && Array.isArray((data as { data?: unknown }).data)) {
    return (data as { data: UpasargaSubantaLink[] }).data;
  }
  return [];
}

export function isUpasargaSubantaLink(x: unknown): x is UpasargaSubantaLink {
  if (!x || typeof x !== 'object') return false;
  const o = x as Record<string, unknown>;
  return (
    typeof o.id === 'number' &&
    typeof o.upasargaId === 'number' &&
    typeof o.subantaId === 'number'
  );
}

export async function listUpasargaSubantas(filters?: {
  upasargaId?: number;
  subantaId?: number;
}): Promise<UpasargaSubantaLink[]> {
  const params: Record<string, number> = {};
  if (filters?.upasargaId != null) params.upasargaId = filters.upasargaId;
  if (filters?.subantaId != null) params.subantaId = filters.subantaId;
  const res = await dictionaryApi.get<unknown>('/upasarga-subanta', {
    params: Object.keys(params).length > 0 ? params : undefined,
  });
  return normalizeList(res.data);
}

export async function getUpasargaSubanta(id: number): Promise<UpasargaSubantaLink> {
  const res = await dictionaryApi.get<UpasargaSubantaLink>(`/upasarga-subanta/${id}`);
  return res.data;
}

export async function createUpasargaSubanta(
  body: CreateUpasargaSubantaBody
): Promise<UpasargaSubantaLink> {
  const res = await dictionaryApi.post<UpasargaSubantaLink>('/upasarga-subanta', body);
  return res.data;
}

export async function updateUpasargaSubanta(
  id: number,
  body: PatchUpasargaSubantaBody
): Promise<UpasargaSubantaLink> {
  const res = await dictionaryApi.patch<UpasargaSubantaLink>(`/upasarga-subanta/${id}`, body);
  return res.data;
}

export async function deleteUpasargaSubanta(id: number): Promise<void> {
  await dictionaryApi.delete(`/upasarga-subanta/${id}`);
}

export function buildUpasargaSubantaPatch(
  prev: UpasargaSubantaLink,
  next: Pick<UpasargaSubantaLink, 'upasargaId' | 'subantaId'>
): PatchUpasargaSubantaBody {
  const patch: PatchUpasargaSubantaBody = {};
  if (prev.upasargaId !== next.upasargaId) patch.upasargaId = next.upasargaId;
  if (prev.subantaId !== next.subantaId) patch.subantaId = next.subantaId;
  return patch;
}
